import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchWlsArrivalReadiness } from '../../utils/wls-api-client';
import { selectReceiptState } from '../../redux/slices/receipt';
import { deriveGuestStayState } from '../../utils/guest-stay-state';

// Loads the authoritative reservation projection once per booking code and
// resolves it into the state the My Stay views render. `null` while the read is
// still in flight, so nothing renders a requirement state it does not yet know.
const useGuestStay = (bookingCode, slug) => {
  const brand = useSelector(state => state.brand);
  const receiptState = useSelector(selectReceiptState);
  const [readiness, setReadiness] = useState(null);
  const [resolved, setResolved] = useState(false);

  useEffect(
    () => {
      if (!bookingCode) {
        return () => {};
      }
      let current = true;
      setResolved(false);
      fetchWlsArrivalReadiness(brand, bookingCode)
        .then(response => {
          if (!current) return;
          setReadiness(response.data || null);
          setResolved(true);
        })
        .catch(() => {
          if (!current) return;
          setReadiness(null);
          setResolved(true);
        });
      return () => {
        current = false;
      };
    },
    [bookingCode]
  );

  if (!resolved) return { stayState: null, loading: true };

  return {
    stayState: deriveGuestStayState({
      readiness,
      receipt: receiptState,
      bookingCode,
      slug
    }),
    loading: false,
    readiness
  };
};

export default useGuestStay;
